import type { History } from 'history';
import React, { Fragment, useEffect } from 'react';
import { withRouter } from 'react-router-dom';

function ScrollToTop({
  history,
  children,
}: {
  history: History;
  children?: any;
}) {
  useEffect(() => {
    const scrollToLocation = (hash?: string) => {
      if (hash) {
        const target = document.querySelector(hash);

        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
      }

      window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    scrollToLocation(history.location.hash);

    const unlisten = history.listen((location) => {
      window.requestAnimationFrame(() => {
        scrollToLocation(location.hash);
      });
    });

    return () => {
      unlisten();
    };
  }, [history]);

  return <Fragment>{children}</Fragment>;
}

export default withRouter(ScrollToTop);
